import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TicketFormData, TicketSummary } from '../types';
import { TicketDetailsStep } from '../steps/TicketDetailsStep';
import { AttachmentsStep } from '../steps/AttachmentsStep';
import { ConfirmationStep } from '../steps/ConfirmationStep';
import { TicketTypesStep } from '../steps/TicketTypesStep';

interface StepManagerProps {
  activeStep: number;
  selectedModule: string;
  form: UseFormReturn<TicketFormData>;
  ticketSummary: TicketSummary;
  createdTicketId: string;
}

export const StepManager: React.FC<StepManagerProps> = ({ 
  activeStep, 
  selectedModule, 
  form, 
  ticketSummary, 
  createdTicketId 
}) => {
  switch (activeStep) {
    case 0:
      return <TicketTypesStep form={form} selectedModule={selectedModule} />;
    case 1:
      return <TicketDetailsStep form={form} selectedModule={selectedModule} />;
    case 2:
      return <AttachmentsStep 
        form={form} 
        ticketSummary={ticketSummary} 
        createdTicketId={createdTicketId} 
      />;
    case 3:
      return <ConfirmationStep ticketSummary={ticketSummary} />;
    default:
      return <div>Unknown step</div>;
  }
};